import actionTypes from './actionTypes';
import { action, generateErrorAction } from '../actions';
import API from '../../apis';

export const getTakeawayFactor = (query) => {
  const request = () => async dispatch => {
    dispatch(loading());

    try {
      const res = await API.takeaway.getTakeawayFactor(query);
      return dispatch(success(res));
    } catch (err) {
      dispatch(
        generateErrorAction(err, {
          failure: actionTypes.GET_TAKEAWAY_FACTOR_FAILED,
          reject: actionTypes.GET_TAKEAWAY_FACTOR_REJECT,
        }),
      );
      throw err;
    }
  };

  function loading() {
    return action(actionTypes.GET_TAKEAWAY_FACTOR_LOADING);
  }

  function success(res) {
    return action(actionTypes.GET_TAKEAWAY_FACTOR_SUCCESS, res);
  }

  return request();
};